<template>
  <div>
    <!-- Flat view. Order matches the original markup: the expandable section
         cards and the leaf resources share one grid, and the opened sub-list
         is appended underneath. -->
    <template v-if="!showAsGroup">
      <ul class="lz-resource-grid" v-if="subSections.length">
        <resource-card
          v-for="subSection in sectionItems"
          :key="'sub_' + subSection.uid"
          :class="{ 'is-wide': listView }"
          :title="subSection.title"
          :is-hidden="subSection.show === false"
          :admin="isAdmin"
          @edit="$emit('edit', subSection)"
          @toggle="$emit('toggle', subSection)">
          <resource-action
            icon="list-nested"
            :label="listView ? 'Hide list' : 'Show list'"
            @click="ToggleList(subSection)" />
        </resource-card>
        <resource-card
          v-for="item in leafItems"
          v-show="!listView"
          :key="item.uid"
          :title="item.title"
          :is-hidden="item.show === false"
          :admin="isAdmin"
          @edit="$emit('edit', item)"
          @toggle="$emit('toggle', item)">
          <resource-action
            v-for="action in LinkActions(item)"
            :key="action.label"
            :icon="action.icon"
            :label="action.label"
            @click="OpenLink(action.link)" />
        </resource-card>
      </ul>

      <ul class="lz-resource-grid lz-resource-sublist" v-if="listItems.length">
        <resource-card
          v-for="item in listItems"
          :key="item.uid"
          :title="item.title"
          :is-hidden="item.show === false"
          :admin="isAdmin"
          @edit="$emit('edit', item)"
          @toggle="$emit('toggle', item)">
          <resource-action
            v-for="action in LinkActions(item)"
            :key="action.label"
            :icon="action.icon"
            :label="action.label"
            @click="OpenLink(action.link)" />
        </resource-card>
      </ul>
    </template>

    <!-- Grouped view: every section rendered as a labelled band. -->
    <template v-else>
      <div
        class="lz-resource-group"
        v-for="group in sectionItems"
        :key="'group_' + group.uid">
        <div class="lz-resource-group-head">
          <span
            class="lz-resource-group-title"
            :class="{ 'is-hidden-resource': group.show === false }"
            >{{ group.title }}</span
          >
          <span class="lz-resource-admin-inline ml-auto" v-if="isAdmin">
            <b-button size="sm" title="Edit" @click.stop="$emit('edit', group)">
              <b-icon-pencil scale="0.8"></b-icon-pencil>
            </b-button>
            <b-button
              size="sm"
              :title="group.show === false ? 'Make visible' : 'Hide'"
              @click.stop="$emit('toggle', group)">
              <b-icon-eye-slash
                v-if="group.show === false"
                scale="0.8"></b-icon-eye-slash>
              <b-icon-eye v-else scale="0.8"></b-icon-eye>
            </b-button>
          </span>
        </div>
        <ul class="lz-resource-grid">
          <resource-card
            v-for="item in group.subSections || []"
            :key="item.uid"
            :title="item.title"
            :is-hidden="item.show === false"
            :admin="isAdmin"
            @edit="$emit('edit', item)"
            @toggle="$emit('toggle', item)">
            <resource-action
              v-for="action in LinkActions(item)"
              :key="action.label"
              :icon="action.icon"
              :label="action.label"
              @click="OpenLink(action.link)" />
          </resource-card>
        </ul>
      </div>
    </template>

    <div class="lz-empty-state" v-if="!sectionItems.length && !leafItems.length">
      <b-icon icon="link45deg" class="lz-empty-icon"></b-icon>
      <p>There aren't any links in this section yet.</p>
    </div>
  </div>
</template>

<script>
import resourceCard from '../resource-card.vue'
import resourceAction from '../resource-action.vue'

export default {
  name: 'ContentComponent',
  components: {
    resourceCard,
    resourceAction
  },
  props: {
    subSections: {
      type: Array,
      required: false,
      default: () => []
    },
    showAsGroup: {
      type: Boolean,
      require: false,
      default: false
    },
    isAdmin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      listView: false,
      listItems: []
    }
  },
  computed: {
    sectionItems() {
      return this.subSections.filter((itm) => itm.subSections)
    },
    leafItems() {
      return this.subSections.filter((itm) => !itm.subSections)
    }
  },
  methods: {
    LinkActions(item) {
      return [
        { link: item.link, icon: 'box-arrow-in-up-right', label: 'Open' },
        { link: item.videoLink, icon: 'camera-video', label: 'Videos' },
        { link: item.filesLink, icon: 'files', label: 'Files' }
      ].filter((action) => action.link)
    },
    OpenLink(link) {
      // noopener: window.open does not imply it the way <a target="_blank"> does,
      // so without it the opened page keeps a handle on window.opener.
      window.open(link, '_blank', 'noopener')
    },
    ToggleList({ subSections }) {
      this.listView = !this.listView
      this.listItems = this.listView ? subSections : []
    }
  }
}
</script>

<style scoped>
.lz-resource-admin-inline .btn {
  padding: 2px 7px !important;
  margin-left: 4px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #475569;
  box-shadow: none !important;
}
.lz-resource-admin-inline .btn:hover {
  background: #fff;
  border-color: #cbd5e1;
  color: #0073be;
}
.is-hidden-resource {
  opacity: 0.55;
}
</style>
